import { render, staticRenderFns } from "./AddressDelegationList.vue?vue&type=template&id=51d0a5db&"
import script from "./AddressDelegationList.vue?vue&type=script&lang=js&"
export * from "./AddressDelegationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports